export default "__VITE_ASSET__85d3af0a__"